import React from 'react';
import { Helmet } from 'react-helmet';
import appBranding from '@happylife-a/branding';

const getField = appBranding.configs.environments.getField;
const getAssets = appBranding.configs.assets.getAsset;
const fieldsAppBranding = appBranding.fields.brand.AppBranding;

function buildHref(filename) {
  return `${getAssets()}/favicon/${filename}`;
}

function CommonFavicon({ size }) {
  const sizes = `${size}x${size}`;
  const href = buildHref(`${sizes}.png`);

  return (
    <>
      <link type="image/png" rel="apple-touch-icon" sizes={sizes} href={href} />
      <link type="image/png" rel="icon" sizes={sizes} href={href} />
    </>
  );
}
function MsMeta({ name, content }) {
  return <meta name={`msapplication-${name}`} content={content} />;
}

const commonFaviconSizes = [
  16, 32, 57, 60, 64, 70, 72, 76, 114, 120, 144, 150, 152, 180, 196, 310, 512,
];

export default function FaviconAndManifest() {
  const themeColor = getField(fieldsAppBranding.ThemeColor);
  const appName = getField(fieldsAppBranding.AppName);

  return (
    <Helmet>
      <meta name="theme-color" content={themeColor} />
      <meta name="msapplication-TileColor" content={themeColor} />
      <meta name="application-name" content={appName} />

      <meta name="apple-mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-status-bar-style" content="black" />
      <meta name="mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-title" content={appName} />

      <link rel="manifest" href={buildHref('manifest.json')} />
      <link type="image/x-icon" rel="shortcut icon" href={buildHref('favicon.ico')} />

      {commonFaviconSizes.map((size) => (
        <CommonFavicon key={size} size={size} />
      ))}

      <MsMeta name="square70x70logo" content={buildHref('70x70.png')} />
      <MsMeta name="square150x150logo" content={buildHref('150x150.png')} />
      <MsMeta name="square310x310logo" content={buildHref('310x310.png')} />
      <MsMeta name="TileImage" content={buildHref('144x144.png')} />
    </Helmet>
  );
}
